import { ApolloClient } from '@apollo/client';
import GET_RECOMMEND_FLIGHT from './recommend.gql';

export const getMinPrice = async ({
  apolloClient,
  scity,
  ecity,
}: {
  apolloClient: ApolloClient<object>;
  scity: string;
  ecity: string;
}) => {
  try {
    const { data } = await apolloClient.query<{
      recommend: { minFare: number };
    }>({
      query: GET_RECOMMEND_FLIGHT,
      variables: { scity, ecity, recommendOnly: false },
    });
    return data.recommend.minFare;
  } catch {
    return 0;
  }
};

export default {};
